import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import SmoothScroll from "./components/SmoothScroll";
import ScrollToTop from "./components/ScrollToTop";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Philosophy from "./pages/Philosophy";
import Approach from "./pages/Approach";
import Sectors from "./pages/Sectors";
import Portfolio from "./pages/Portfolio";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <SmoothScroll>
          <div className="App">
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/philosophy" element={<Philosophy />} />
                <Route path="/approach" element={<Approach />} />
                <Route path="/sectors" element={<Sectors />} />
                <Route path="/portfolio" element={<Portfolio />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <Toaster
              position="bottom-right"
              theme="light"
              toastOptions={{ style: { fontFamily: "Outfit, sans-serif" } }}
            />
          </div>
        </SmoothScroll>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
